import { WithChildrenProps } from '@app/types/generalTypes';
import React from 'react';
import { Helmet } from 'react-helmet';

export const PageTitle: React.FC<WithChildrenProps> = ({ children }) => {
  // const toTitleCase = (str: string) => {
  //   return str.replace(/\b\w/g, (char) => char.toUpperCase());
  // };

  return (
    <Helmet>
      <title>{children} | Q3S Language</title>
    </Helmet>
  );
};
